import React, { useEffect, useState } from "react";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";
import { AnimatePresence, motion } from "framer-motion";
import SecondaryHeader from "./SecondaryHeader";

export default function Header({ isOpen, setOpen, type, isHeaderFixed, id }) {
  const [isVisible, setIsVisible] = useState(true);
  const listenToScroll = () => {
    let heightToHideFrom = 800;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && // to limit setting state only the first time
        setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  });
  console.log("isHeaderFixedzzz in header", isHeaderFixed);
  return (
    <div
      className={`${
        isOpen ? "fixed" : "relative"
      } fixed w-full top-0 left-0 right-0 z-50`}
    >
      {type === "primary" ? (
        <HeaderDesktop isHeaderFixed={isHeaderFixed} />
      ) : (
        <SecondaryHeader id={id} isHeaderFixed={isHeaderFixed} />
      )}
      <HeaderMobile isOpen={isOpen} setOpen={setOpen} type={type} />
      <AnimatePresence>
        {!isVisible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            id="hide"
            className="bg-yellow-500 w-screen top-0 left-0 right-0 fixed"
          ></motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
